import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';
import { CSSProperties, useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { ISanityImage } from 'typescriptDefs';

import { addNonBreakingSpaces } from 'helpers/addNonBreakingSpaces';

import { LocaleContext } from './Layout';

type Perk = {
  description: string;
  icon: ISanityImage | null;
  iconAltText?: string | null;
};

const Perk = ({ perk: { description, icon, iconAltText } }: { perk: Perk }) => {
  const locale = useContext(LocaleContext);
  return (
    <div className="perkContainer flex flex-col items-center">
      <div className="flex h-42 justify-center">
        {icon && (
          <GatsbyImage
            className="max-h-32 max-w-172"
            objectFit="contain"
            image={icon.asset?.gatsbyImageData}
            role="presentation"
            alt={iconAltText ?? ''}
          />
        )}
      </div>
      <span
        className="inline-block pt-12 text-center text-md leading-150"
        dangerouslySetInnerHTML={{ __html: locale === 'fr' ? addNonBreakingSpaces(description) : description }}
      />
    </div>
  );
};

type Props = {
  className?: string;
  perks: Perk[];
};

export const Perks = ({ className, perks }: Props) => {
  return (
    <div
      className={twMerge(
        clsx('grid grid-cols-2 gap-32 md:[grid-template-columns:repeat(var(--numCols),minmax(0,1fr))]', className),
      )}
      style={{ '--numCols': Math.min(perks.length, 4) } as CSSProperties}
    >
      {perks.map((perk, i) => (
        <Perk key={i} perk={perk} />
      ))}
    </div>
  );
};
